<h2>Region
    <b *ngIf="regionName"> {{regionName}} </b>
</h2>




<button (click)="deletePolygon()" *ngIf="removeRegion" class="btn btn-warning">Remove Polygon</button>

<button (click)="removePolygon()" *ngIf="deleteRegion" class="btn btn-danger">Remove Region</button>

<button (click)="refreshMap()" class="btn btn-primary">Update Map</button>



<div *ngIf="polygonEnd" class="admin-form">
    <br>
    <div class="row">
        <div class="col-md-4">
          <mat-form-field class="example-full-width">
            <mat-label>Region</mat-label>
            <input matInput [(ngModel)]="nameregion" name="namregion" id="nameregion" placeholder="Region Name">
          </mat-form-field>


        </div>
    </div>
    <div class="row">

        <div class="col-md-4">


                <input [(colorPicker)]="color" [(ngModel)]="color" class="form-control" style="color: white" [style.background]="color" />

        </div>

        <button (click)="addRegion()" class="btn btn-primary">Save Region</button>

    </div>
</div>
<br>
<div id="map">


</div>
